module.exports = __webpack_public_path__ + "img/IMG_2729_FoamcoreMatted.fb283131.jpg";